<div mat-dialog-content>
  <h2>
    {{ data.title | translate }}
    <button mat-dialog-close type="button" class="orms-close-button"></button>
  </h2>
  <app-visualization [treeData]="data.visualization"></app-visualization>
</div>
